// Jurisdiction pill — flag + localised label + a colour dot. Pure
// presentation (W1): the colour/flag come from the local `case-jurisdiction`
// map (plan §2.7 — not a leak), the label from i18n. Logical RTL utilities
// only (CLAUDE.md §9.2); the label is a generic country name so it needs no
// per-string bidiProps (it is not BE-emitted legal content).

import { useTranslation } from 'react-i18next'
import { jurisdictionDisplay } from './case-jurisdiction'

export interface JurisdictionBadgeProps {
  /** Wire jurisdiction code (e.g. `FR`, `ma`). Case-insensitive. */
  code: string
}

export function JurisdictionBadge({
  code,
}: JurisdictionBadgeProps): JSX.Element {
  const { t } = useTranslation()
  const display = jurisdictionDisplay(code)

  return (
    <span
      data-testid={`jurisdiction-badge-${code.toLowerCase()}`}
      className="inline-flex w-fit shrink-0 items-center gap-1 rounded-full border border-ink/10 bg-ink/[0.03] px-1.5 py-0.5 text-[10px] font-semibold text-ink/70"
    >
      <span
        aria-hidden="true"
        data-testid="jurisdiction-badge-dot"
        className="h-1.5 w-1.5 shrink-0 rounded-full"
        style={{ backgroundColor: display.color }}
      />
      <span aria-hidden="true">{display.flag}</span>
      <span>{t(display.labelKey)}</span>
    </span>
  )
}
